import LanguageManager from '../language_manager/language_manager';
import safe from '../../util/safe';
import DomUtils from '../../util/dom_utils';
import StarzplayerConstants from '../../starzplayer_constants';

const HttpUtils = require('../../util/http_utils');
const StringUtils = require('../../util/string_utils').default;
const config = require('../../config');
const ErrorHandler = require('../error_handler/error_handler');

export default {

    init(emitter, seriesContent) {
        
        this.emitter = emitter;
        this.seriesContent = seriesContent;

        const btn = document.querySelector('.play-next') ? document.querySelector('.play-next') : this.addIcon();
        this.handleButtonVisibility(btn);
        
    },
 
    addIcon() {
        const btn = document.createElement('button');
        const oldCaptionsBtn = document.getElementsByClassName('bitdash-captions')[0];
        btn.setAttribute('type', 'button');
        btn.setAttribute('class', 'play-next');
        btn.innerHTML = 'Next Episode';

        const toolTip = document.createElement('div');
        toolTip.classList.add('bitdash-btns');
        toolTip.classList.add('bitdash-btns-next-episode');
        toolTip.setAttribute('data-tooltip', LanguageManager.get('tooltip_next_episode'));
        oldCaptionsBtn.parentNode.insertBefore(toolTip, oldCaptionsBtn);
        toolTip.appendChild(btn);
        this.hideButton(oldCaptionsBtn);
        return btn;
    },

    hideButton(btn) {
        btn.style.display = 'none';
    },

    handleButtonVisibility(btn) {
        //hide the button and dont bind any event in case of last episode
        return this.isLastEpisode() ? this.hideButton(btn) : this.events(btn);
    },

    isLastEpisode(){
        return !this.seriesContent.nextEpisode;
    },

    events(btn) {
        btn.onclick = event => {
            this.emitter.emit('next-episode');
        }
    }
};
 


// WEBPACK FOOTER //
// ./src/modules/controls/next_episode_control.js